import * as React from "react"

function SvgPlus(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.583 6.417h5.25v1.166h-5.25v5.25H6.417v-5.25h-5.25V6.417h5.25v-5.25h1.166v5.25z"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgPlus

